var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"im-tip flex w-full items-center"},[_c('icon-warn'),_vm._v(" "),_c('span',{staticClass:"text-white text-12 ml-2"},[_vm._v(_vm._s(_vm.text))])],1)
}
var staticRenderFns = []

export { render, staticRenderFns }